/* unplugin-vue-components disabled */import { render } from "./FooterForMobile.vue?vue&type=template&id=790bee94&scoped=true"
import script from "./FooterForMobile.vue?vue&type=script&lang=js"
export * from "./FooterForMobile.vue?vue&type=script&lang=js"

import "./FooterForMobile.vue?vue&type=style&index=0&id=790bee94&lang=less&scoped=true"

import exportComponent from "/Users/jiaohong/Documents/code/workSpace/kuaitandain-official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790bee94"]])

export default __exports__